import React from 'react';
import { useSearchParams } from 'react-router-dom';
import ScanJudge from './ScanJudge';
import GlowupJudge from './GlowupJudge';

// /judge — mode selector only.
//
// Each deck owns its own AppLayout and header, so this cannot render both or
// wrap them; it picks one. The alternative (hoisting a shared shell) would
// mean refactoring the 359-line GlowupJudge, for no user-visible gain.
//
// Scan judging is the DEFAULT: it is the path that unlocks a reading, so an
// arriving user should land on it without a click. ?mode=glowup opts into the
// two-photo deck.
export default function JudgeRoute() {
  const [searchParams] = useSearchParams();
  return searchParams.get('mode') === 'glowup' ? <GlowupJudge /> : <ScanJudge />;
}
